let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5s93s")).then(() => parcelRequire('lCdh2'));